document.addEventListener("DOMContentLoaded", function (event) {
  let clearBtn = document.querySelector("#clear-discount-btn");
  let applyBtn = document.querySelector("#apply-discount-btn");
  let discountCodeError = document.querySelector("#discount-code-error");
  let discountCodeWrapper = document.querySelector(
    "#applied-discount-code-wrapper"
  );
  let discountCodeValue = document.querySelector(
    "#applied-discount-code-value .discount-code"
  );
  let discountCodeInput = document.querySelector("#discount-code-input");
  let totalCartSelector = document.querySelector(".totals__total-value"); // Total Cart Selector to update the total amount.
  let authorization_token;

  let checkoutContainer = document.createElement("div");
  document.body.appendChild(checkoutContainer);
  if (localStorage.discountCode)
    applyDiscount(JSON.parse(localStorage.discountCode).code);
  applyBtn.addEventListener("click", function (e) {
    e.preventDefault();
    applyDiscount(discountCodeInput.value);
  });
  clearBtn.addEventListener("click", function (e) {
    e.preventDefault();
    clearDiscount();
  });

  async function manageError() {
    await fetch("/discount/+?redirect=/checkout");
    var val = $("#applied-discount-code-value .discount-code").attr(
      "data-price"
    );
    totalCartSelector.innerHTML = "₹ " + val.toLocaleString();
  }

  function clearDiscount() {
    discountCodeValue.innerHTML = "";
    discountCodeError.innerHTML = "";
    clearLocalStorage();
    // fetch("/checkout?discount=%20");
    fetch("/discount/+?redirect=/checkout");
  }
  function clearLocalStorage() {
    discountCodeWrapper.style.display = "none";
    try {
      totalCartSelector.innerHTML =
        "₹ " + JSON.parse(localStorage.discountCode).totalCart.toLocaleString();
      localStorage.removeItem("discountCode");
    } catch (error) {}
  }
  function applyDiscount(code) {
    applyBtn.innerHTML = "APPLYING <div class='loader'></div>";
    applyBtn.style.pointerEvents = "none";
    fetch("/payments/config", { method: "GET" })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const checkout_json_url = "/wallets/checkouts/";
        authorization_token = btoa(data.paymentInstruments.accessToken);
        fetch("/cart.js", {})
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            let body = {
              checkout: {
                country: Shopify.country,
                discount_code: code,
                line_items: data.items,
                presentment_currency: Shopify.currency.active,
              },
            };
            fetch(checkout_json_url, {
              headers: {
                accept: "*/*",
                "cache-control": "no-cache",
                authorization: "Basic " + authorization_token,
                "content-type": "application/json, text/javascript",
                pragma: "no-cache",
                "sec-fetch-dest": "empty",
                "sec-fetch-mode": "cors",
                "sec-fetch-site": "same-origin",
              },
              referrerPolicy: "strict-origin-when-cross-origin",
              method: "POST",
              mode: "cors",
              credentials: "include",
              body: JSON.stringify(body),
            })
              .then(function (response) {
                return response.json();
              })
              .then(function (data) {
                if (
                  data.checkout &&
                  data.checkout.applied_discounts.length > 0
                ) {
                  let discountApplyUrl =
                    "/discount/" +
                    code +
                    "?v=" +
                    Date.now() +
                    "&redirect=/checkout/";
                  fetch(discountApplyUrl, {}).then(function (response) {
                    return response.text();
                  });
                  discountCodeWrapper.style.display = "inline";
                  discountCodeError.innerHTML = "";
                  discountCodeValue.innerHTML =
                    "<span class='text-success''>Applied </span>" +
                    data.checkout.applied_discounts[0].title;
                  let localStorageValue = {
                    code: code.trim(),
                    totalCart: data.checkout.total_line_items_price,
                  };
                  localStorage.setItem(
                    "discountCode",
                    JSON.stringify(localStorageValue)
                  );
                  totalCartSelector.innerHTML =
                    "₹ " +
                    Math.round(data.checkout.total_price).toLocaleString();
                } else {
                  discountCodeValue.innerHTML = "";
                  clearLocalStorage();
                  manageError();
                  discountCodeError.innerHTML =
                    "Please Enter Valid Coupon Code.";
                }
              })
              .finally(function (params) {
                applyBtn.innerHTML = "APPLY";
                applyBtn.style.pointerEvents = "all";
              });
          });
      });
  }
});

var infiniteScrolling = {
  loading: false,
  containerSelector: "#colelction-pagination",
  init: function () {
    var self = this;
    $(window).on("scroll", function () {
      if (!self.loading && self.isScrolledIntoView($(self.containerSelector))) {
        // Check if the next-page-link class is present before loading more
        if ($(".next-page-link").length) {
          self.loadMore();
        } else {
          console.log("Next page link not found. Stopping scrolling.");
        }
      }
    });
  },
  loadMore: function () {
    var self = this;
    self.loading = true;
    const url = $(".next-page-link").attr("href");

    console.log("calling load more");

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        const newHtml = new DOMParser()
          .parseFromString(html, "text/html")
          .getElementById("product-grid").innerHTML;
        $("#product-grid").append(newHtml);

        const newURL = new DOMParser()
          .parseFromString(html, "text/html")
          .getElementById("colelction-pagination").innerHTML;
        $("#colelction-pagination").html(newURL);
      })
      .finally(() => {
        self.loading = false;
      });
  },
  isScrolledIntoView: function (elem) {
    try {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();
      var elemTop = $(elem).offset() ? $(elem).offset().top : 0;
      var elemBottom = elemTop + $(elem).height();
      return elemBottom <= docViewBottom;
    } catch (error) {
      console.log(error);
    }
  },
};

$(document).ready(function () {
  infiniteScrolling.init();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $(".scroll_top").fadeIn();
    } else {
      $(".scroll_top").fadeOut();
    }
  });
  $(".scroll_top").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
});

$(document).ready(function () {
  try {
    document
      .getElementById("dropdownMenuButton2")
      .addEventListener("click", function () {
        if (navigator.share) {
          navigator
            .share({
              title: this.getAttribute("data-title"),
              // text: 'Portronics',
              url: this.getAttribute("data-url"),
            })
            .then(() => console.log("Successful share"))
            .catch((error) => console.log("Error sharing:", error));
        } else {
          console.log("Web Share API not supported on this browser");
          // Provide a fallback sharing mechanism or UI here (e.g., open a shareable link)
          alert("Use your device's native sharing options.");
        }
      });
  } catch (error) {}

  try {
    detail();
  } catch (error) {}

  $("a.video").fancybox({
    transitionIn: "elastic",
    transitionOut: "elastic",
    speedIn: 600,
    speedOut: 200,
    overlayShow: false,
  });

  $("#Subscribe").click(function (e) {
    e.preventDefault();
    // Get the form data
    var formData = $("#ContactFooter").serialize();
    $(".loading-submit").show();

    // Make the AJAX request
    $.ajax({
      type: "POST",
      url: "/contact",
      data: formData,
      success: function (responseText) {
        // Handle the successful response
        // console.log('Form submitted successfully:', responseText);

        const html = responseText;
        const newHtml = new DOMParser()
          .parseFromString(html, "text/html")
          .getElementById("content-notification").innerHTML;
        $("#content-notification").html(newHtml);
        $(".loading-submit").hide();

        setTimeout(function () {
          $("#content-notification").html("");
        }, 2000);
      },
      error: function (error) {
        // Handle errors
        $("#content-notification").html(
          `<small class="newsletter-form__message form__message" id="ContactFooter-error">Too Many Requests, Try After Sometime.</small>`
        );
        $(".loading-submit").hide();
      },
    });
  });

  document.addEventListener("click", function (event) {
    var epcotDetails = document.getElementById("Details-HeaderMenu-1");
    var targetElement = event.target;

    // Check if the click is outside the details element
    if (!epcotDetails.contains(targetElement)) {
      // Close the details element
      epcotDetails.removeAttribute("open");
    }
  });

  $(".reset-click").on("click", function () {
    console.log("adsaddasds");
    $('button[type="button"]').attr("aria-expanded", false);
  });

  $(".sortbyBtn").on("click", function () {
    $("#main-collection-filters").addClass("active sortByDetail");
    $('.js-filter[data-index="0"]').attr("open", true);
  });

  $(".filterBtn").on("click", function () {
    $("#main-collection-filters").removeClass("sortByDetail");
    $("#main-collection-filters").addClass("active");
  });

  $(".fiter-btnz a, .cls-icon").on("click", function () {
    $("#main-collection-filters").removeClass("active");
    $("#main-collection-filters").removeClass("sortByDetail");
  });

  $(".sortBYList .facet-checkbox").on("click", function () {
    $("#main-collection-filters").removeClass("active");
    $("#main-collection-filters").removeClass("sortByDetail");
  });

  if ($(window).width() < 767) {
    $('.js-filter[data-index="0"]').attr("open", true);

    $('.js-filter[data-index="1"]').attr("open", true);

    $(document).on("click", ".js-filter", function (e) {
      e.stopPropagation();
    });

    $(document).on("click", ".facets__summary", function (e) {
      $(".js-filter").removeAttr("open");
      $(this).parent().attr("openasdasd", "sadsad");
    });
  }

  $(document).on("click", function (e) {
    var $target = $(e.target);
    if (
      !$target.closest(".toggle-menu").length &&
      !$target.closest("#mob-nav").length
    ) {
      $(".toggle-menu").removeClass("active");
      $(".mob-nav").removeClass("active"); 
    $('body').addClass('menu_open')
    }
  });
  $("#mob-nav").on("click", function (e) {
    var mobNavWidth = $(this).width();
    var threshold = mobNavWidth * 0.15;
    if (e.offsetX > threshold) {
      // Clicked on the rest 15%, do nothing
      return;
    }

    // Clicked on the main content area, remove the 'active' class
    // $(this).removeClass("active");

    // Check if the click occurred outside of the header__inline-menu
    if ($(e.target).closest(".header__inline-menu").length === 0) {
      // Clicked outside of header__inline-menu, close the menu
      $(".toggle-menu").removeClass("active");
      $("#mob-nav").removeClass("active");
      $('body').removeClass('menu_open')
    }
  });

  $(".toggle-menu").on("click", function (e) {
    e.preventDefault();
    var id = $(this).attr("href");
    $(id).toggleClass("active");
    $(this).toggleClass("active");
  });

  $(".toggle-cat").on("click", function () {
    $(".toggle-menu").click();
  });

  var isClassAdded = false; // Initialize a variable to track the class state

  $(".drop-men").click(function () {
    var $parent = $(this).parent();

    if (isClassAdded) {
      // Remove the 'active' class from the parent div
      $parent.removeClass("active");
      $(this).removeClass("active");
    } else {
      // Add the 'active' class to the parent div
      $parent.addClass("active");
      $(this).addClass("active");
    }

    // Toggle the class state
    isClassAdded = !isClassAdded;
  });

  $(".mob-nav .mega-menu").attr("open", true);

  $(".link-cls").on("click", function () {
    const id = $(this).attr("data-id");
    $(id).find(".more-product").slideToggle();
    $(this).hide();
  });

  var video = document.getElementById("video");

  $(".play-icon").on("click", function () {
    if (video.paused) {
      $(".product-video").removeClass("active");
      video.play();
    } else {
      $(".product-video").addClass("active");
      video.pause();
    }
  });

  $(".click-nav").on("click", "a", function (e) {
    e.preventDefault();
    var id = $(this).attr("href");

    $("html, body").animate(
      {
        scrollTop: $(id).offset().top - 80,
      },
      400
    );
  });

  $(".tab-nsv").each(function () {
    var url = $(this).find("a.active").parent().attr("data-url");
    var id = $(this).find("a.active").parent().attr("data-id");
    $("a[link-id=" + id + "]").attr("href", url);
  });

  async function fetchProductReviews() {
    try {
      const productRateElements = $(".product-rate");

      for (const element of productRateElements) {
        const id = $(element).attr("data-id");

        const response = await $.ajax({
          type: "POST",
          url: "/apps/aliexpress_reviews",
          data: {
            product_id: id,
            customer_id: "",
          },
        });

        $("body").append(
          `<div style="display:none;" id="az_reviews_${id}"></div>`
        );

        const parser = new DOMParser();
        const responseDoc = parser.parseFromString(response, "text/html");

        // Get the body content from the parsed document
        const responseBody = responseDoc.querySelector(".Products_reviews");

        console.log(responseBody);

        // $(`#az_reviews_${id}`).html(responseBody);

        if (1 === 1) {
          // Consider whether this condition is needed
          const productRating = $(`#az_reviews_${id}`)
            .find(".Products_reviews")
            .html();
          // console.log(productRating);
        }
      }
    } catch (error) {
      $(".areviews_loading").hide();
      $(".areviews_loading").remove();
      console.error("An error occurred:", error);
    }
  }

  // fetchProductReviews();

  $(".cart-mobile").on("click", function () {
    $("cart-drawer").addClass("animate");
    $("cart-drawer").addClass("active");
    $("html, body").addClass("overflow-hidden-body");

    console.log("cart button active");
  });

  $(".search-mob").on("click", function (e) {
    e.preventDefault();

    var $searchOpen = $(".mobile-header #search-open");
    var isOpen = $searchOpen.attr("open");

    if (isOpen == "open") {
      $searchOpen.removeAttr("open");
    } else {
      $searchOpen.attr("open", "true");
    }
  });

  $(".searchClick").on("click", function (e) {
    e.preventDefault();

    var $searchOpen = $("#search-open");
    var isOpen = $searchOpen.attr("open");

    if (isOpen == "open") {
      $searchOpen.removeAttr("open");
    } else {
      $searchOpen.attr("open", "true");
    }
  });

  $(".spec-div label").each(function () {
    var originalString = $(this).text();
    var modifiedString = originalString.replace(/:/g, ""); // Replace all occurrences of ":"
    $(this).text(modifiedString);
  });

  $(".change-toggle h4").on("click", function () {
    $(this).find("span").toggleClass("fo-plus fo-minus");
    $(this).parent().find("ul").slideToggle();
  });

  const header = $("header");
  const headerHeight = header.outerHeight();

  function handleScroll() {
    const scrollPosition = $(window).scrollTop();

    if (scrollPosition >= headerHeight) {
      header.addClass("scrolled");
    } else {
      header.removeClass("scrolled");
    }
  }

  $(window).on("scroll", handleScroll);

  $(".click-link").on("click", function () {
    var link = $(this).attr("data-url");
    var id = $(this).attr("data-id");
    $("a[link-id=" + id + "]").attr("href", link);
  });

  function initializeSlick() {
    $("#collectionSlider").slick({
      dots: false,
      arrows: true,
      speed: 900,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow:
        "<button type='button' class='slick-prev'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
      nextArrow:
        "<button type='button' class='slick-next'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
      infinite: false,
    });
  }

  function destroySlick() {
    $("#collectionSlider").slick("unslick");
  }

  // Check screen width on page load
  if ($(window).width() > 768) {
    initializeSlick();
  }

  // Check screen width on resize
  $(window).resize(function () {
    if ($(window).width() > 768) {
      if (!$("#collectionSlider").hasClass("slick-initialized")) {
        initializeSlick();
      }
    } else {
      destroySlick();
    }
  });

  $(".announceMent").slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });

  $(".top-slider.dataS").slick({
    dots: false,
    arrows: false,
    autoplay: false,
    speed: 900,
    infinite: false,
    asNavFor: ".th-slider",
    responsive: [
      {
        breakpoint: 1024,
        settings: {},
      },
      {
        breakpoint: 768,
        settings: {
          dots: true,
        },
      },
    ],
  });

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  var variantId = getParameterByName("variant");

  if (variantId) {
    const id = variantId;
    const selector = `[data-id="${id}"]`; // Dynamic selector based on id
    var index = $(selector).attr("data-slick-index");

    setTimeout(() => {
      $(".top-slider.dataS").slick("slickGoTo", index);
    }, 1);
  }

  $(".th-slider").slick({
    dots: false,
    arrows: true,
    autoplay: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 900,
    asNavFor: ".top-slider",
    focusOnSelect: true,
    vertical: true,
    infinite: false,
    prevArrow:
      "<button type='button' class='slick-prev'><i class='fa fa-angle-up' aria-hidden='true'></i></button>",
    nextArrow:
      "<button type='button' class='slick-next'><i class='fa fa-angle-down' aria-hidden='true'></i></button>",
  });

  $(".slick-banner").slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 900,
  });

$("#scroll-start").slick({
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 900,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true
});


  $(".product__media-list_").slick({
    dots: false,
    arrows: false,
    // autoplay: true,
    // autoplaySpeed: 3000,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $("#blog-slider").slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });

  // Set the offer expiration date and time (in UTC)
  const offerExpirationDate = new Date("2023-09-01T12:00:00Z");

  // Function to update the timer
  function updateTimer() {
    try {
      const now = new Date();
      const timeRemaining = offerExpirationDate - now;

      if (timeRemaining <= 0) {
        // Offer has expired
        document.getElementById("timer").innerHTML = "Offer has expired.";
      } else {
        // Calculate time remaining in hours, minutes, and seconds
        const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
        const minutes = Math.floor(
          (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        // Format numbers with leading zeros if they are less than 10
        const formattedHours = hours.toString().padStart(2, "0");
        const formattedMinutes = minutes.toString().padStart(2, "0");
        const formattedSeconds = seconds.toString().padStart(2, "0");

        // Display the remaining time
        document.getElementById(
          "timer"
        ).innerHTML = `<div>${formattedHours}</div> : <div>${formattedMinutes}</div> : <div>${formattedSeconds}</div>`;
      }
    } catch (error) {
      console.log(error);
    }
  }

  const htmlContent = $("#main-desktop").html();
  $("#main-mobile").html(htmlContent);

  var oneFourth = $(window).width() / 3.75;

  $("#main-mobile").find(".data-categ").css("width", oneFourth);

  $("#main-mobile").slick({
    dots: false,
    arrows: false,
    autoplay: false,
    // autoplaySpeed: 3000,
    // speed: 900,
    slidesToShow: 4,
    //centerMode: true,
    // variableWidth: true,
    loop: false,
    touchThreshold: 10,
    useTransform: false,
    clone: false,
    infinite:false,
   centerMode: false,
    //speed: 400, // Adjust the speed of sliding
    // easing: 'ease', // Adjust the easing function
    slidesToScroll: 1,
    //centerPadding: '0px',
    prevArrow:
      "<button type='button' class='slick-prev'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:
      "<button type='button' class='slick-next'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    responsive: [
      {
        breakpoint: 768, // Medium devices (tablets, 768px and up)
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // Small devices (phones, 480px and up)
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: false,
          infinite:false,
        },
      },
    ],
  });
  var numItems = $("#main-mobile .slick-slide").length;
  if (numItems < 4) {
    // Destroy the Slick slider
    $("#main-mobile").slick("unslick");
  }

  // $(document).ready(function(){
  //      $(".nx-nav a").click(function(){
  //       $("a").addClass("active");
  //      })
  // });

  // Update the timer every second
  // setInterval(updateTimer, 1000);

  // Initial call to update the timer to avoid delay in displaying the time
  // updateTimer();

  var footerPosition = $("footer").offset().top;

  // Add a scroll event listener
  $(window).scroll(function () {
    // Check if the scroll position is greater than or equal to the footer position
    if ($(window).scrollTop() >= footerPosition) {
      // Add the 'highlight' class to the section
      $(".product-form, .filter-options").addClass("highlight");
    } else {
      // Remove the 'highlight' class if scroll position is above the footer
      $(".product-form, .filter-options").removeClass("highlight");
    }
  });

  $("#MainContent #product-rating a").on("click", function (e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $("#reviews").offset().top - 80,
      },
      400
    );
  });

  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });

  $(".copy-url").click(function (event) {
    event.preventDefault(); // Prevent the link from navigating

    // Get the href attribute
    var hrefValue = $(this).attr("href");

    // Create a temporary input element
    var tempInput = $("<input>");
    $("body").append(tempInput);

    // Set the value and select the input content
    tempInput.val(hrefValue).select();

    // Execute copy command
    document.execCommand("copy");

    // Remove the temporary input
    tempInput.remove();

    $(this).attr("data-bs-original-title", "Url Copied").tooltip("show");

    setTimeout(function () {
      $(".copy-url").tooltip("hide");
      $("#dropdownMenuButton1").dropdown("toggle");
      $(".copy-url").attr("data-bs-original-title", "Copy URL");
    }, 2500);
  });

  $(".dropdown").hover(
  function () {
    $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(500);
  },
  function () {
    $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(500);
  }
);


  $("#SearchModalInput").on("input", function () {
    var search_value = $(this).val();
    var show_url = window.location.origin;
    $("a.search--app--data").attr(
      "href",
      show_url + "/pages/rapid-search-results?q=" + search_value
    );
  });

  $(".quick-add__submit").click(function () {
    $(".quick-add-modal .slick_product_slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      draggable: false,
      asNavFor: ".slick_product_thum",
    });
    $(".quick-add-modal .slick_product_thum").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: ".slick_product_slider",
      arrows: true,
      dots: false,
      prevArrow:
        '<button class="slide-arrow prev-arrow"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
      nextArrow:
        '<button class="slide-arrow next-arrow"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      focusOnSelect: true,
    });
    setTimeout(function () {
      productSlider();
    }, 2500);
  });
});

function productSlider() {
  const colorRadios = document.querySelectorAll(
    '.product-form__input input[name="Color"]'
  );
  console.log(colorRadios);

colorRadios.forEach((radio) => {
  radio.addEventListener("click", () => {
    if (radio.checked) {
      $(".product_variant_slider_row").each(function () {
        const alt = $(this).data("alt");
        console.log('radio value:',radio.value);
        if (alt === radio.value) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
      $(".slick_product_thum").slick("refresh");
      $(".slick_product_slider").slick("refresh");
      $(".slick_slider_main .slider2").hide();
      $(".slick_product_slider").slick("slickGoTo", 0); // Go to the first slide
    }
  });
});

}

window.onload = function () {
  productSlider();
};


document.querySelector('.searchClick').addEventListener('click', function(){
    setTimeout(function(){
      document.querySelector(".search__input").focus();  
    },500)
});

var pageProductElement = document.querySelector('.page_product');
if (pageProductElement && pageProductElement.querySelector('#faq')) {
    var descriptionTabElement = pageProductElement.querySelector('.product__description_tab');
    if (descriptionTabElement) {
        descriptionTabElement.classList.add('faq_not_showing');
    }
}

$(window).on("scroll", () => {
  $("[touching]").each(function() {
    var className = $(this).attr("touching");
    var offset = $(this).offset().top - $(window).scrollTop();
    if (offset <= 60) {
      $(this).addClass(className);
    } else {
      $(this).removeClass(className);
    }
  });
}).trigger("scroll");

setTimeout(function(){
 var parentElement = document.querySelector('#scroll-start');
  var ulElements = parentElement.querySelector('.slick-dots');
    if (ulElements && ulElements.children.length <= 1) {
        ulElements.style.display = 'none';
    }
}, 1000)

$(document).ready(function(){
    $('.video-section').find('video').get(0).play();

  $('.toggle-menu .open_menu').click(function(){
    $('body').addClass('active_menu')
  })
  $('.toggle-menu .close_menu').click(function(){
    $('body').removeClass('active_menu')
  })
  $('#chategare_section').click(function(){
    $('.toggle-menu').toggleClass('active');
  })

})

window.addEventListener('load', function() {
    setTimeout(function(){
      var productVideo = document.querySelector('.product-video')
      var videoButton = productVideo.querySelector('.play-icon')
      videoButton.click()
      var video = document.getElementById('video');
      video.autoplay = true;
      video.muted = true;
      video.loop = true;
    }, 1000)
});
$(document).ready(function() {
    adjustMobNavPosition(); 
    $(window).on('resize scroll', function() {
        adjustMobNavPosition();
    });

    function adjustMobNavPosition() {
        var headerHeight = $('header').outerHeight(); 
        var announcementHeight = $('.announcement-bar-section').outerHeight() || 0; 
        var headerSum = headerHeight + announcementHeight;

        if ($(window).scrollTop() >= 70) {
            $("body").addClass("header_sticky");
            $('.mob-nav, cart-drawer').css({
                'top': headerHeight + 'px',
                'height': `calc(100% - ${headerHeight}px)`
            });
        } else {
            $("body").removeClass("header_sticky");
            $('.mob-nav, cart-drawer').css({
                'top': headerSum + 'px',
                'height': `calc(100% - ${headerSum}px)`
            });
        }
    }
});












